import uploadsarticlesbestCriminalDefenseLawyerInElkGroveimageshutterstock_7967345771600x900Jpg from "$lib/data/generated/uploads/articles/best-criminal-defense-lawyer-in-elk-grove/image/shutterstock_796734577-1600x900.jpg";

export const uploads = {
  "uploads/articles/best-criminal-defense-lawyer-in-elk-grove/image/shutterstock_796734577-1600x900.jpg": uploadsarticlesbestCriminalDefenseLawyerInElkGroveimageshutterstock_7967345771600x900Jpg
};